import { Button } from '@/components/ui/button';
import PropTypes from 'prop-types';
import { showToast } from '@/config/toast.config';

const ErrorToast = ({ message, errorData, disableCopy = false }) => {
  const handleCopy = async () => {
    try {
    let text;
    if (errorData instanceof Error) {
      const plainError = {};
      Object.getOwnPropertyNames(errorData).forEach(key => {
        plainError[key] = errorData[key];
      });
      text = JSON.stringify(plainError, null, 2);
    } else if (typeof errorData === 'object' && errorData !== null) {
      text = JSON.stringify(errorData, null, 2);
    } else {
      text = String(errorData);
    }
    await navigator.clipboard.writeText(text);
    } catch (error) {
      showToast.error(error);
    }
  };
  // Truncate displayed error message to a few lines
  const MAX_LINES = 3;
  const lines = message ? message.split('\n') : [];
  const displayMessage = lines.length > MAX_LINES
    ? [...lines.slice(0, MAX_LINES), '...'].join('\n')
    : message;

  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex-1 mr-4">
        {displayMessage && <div style={{ whiteSpace: 'pre-line' }}>{displayMessage}</div>}
      </div>
      {errorData && !disableCopy && (
        <Button
          variant="secondary"
          size="xs"
          onClick={handleCopy}
        >
          Copiează
        </Button>
      )}
    </div>
  );
};

ErrorToast.propTypes = {
  message: PropTypes.string,
  errorData: PropTypes.any,
  disableCopy: PropTypes.bool,
};

export default ErrorToast; 